<template>
  <div>
    <span v-for="(tag, index) in tags" :key="index" class="mr-2">
      <span class="regular-16">{{tag}}<span v-if="index < tags.length - 1">,</span></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'KeywordSection',
  props: ['tags'],
}
</script>
